export { gte as default } from "@ember/helper";
